import { render, staticRenderFns } from "./invoiceDataTable.vue?vue&type=template&id=46b63993&"
import script from "./invoiceDataTable.vue?vue&type=script&lang=js&"
export * from "./invoiceDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports